<template>
  <div>
    <div class="ts-grid ts-grid-cols-1 ts-gap-3">
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0 required">
            {{ $t('serviceRequest.requestedBy') }}
          </label>
          <a-select
            v-model="model.requested_by"
            :options="customers"
            allowClear
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('requested_by') }"
            placeholder="Select"
            @change="onChangeRequestBy"
            @search="handleSearchCustomer"
            :loading="customer_searching"
          ></a-select>
          <div class="validate" v-if="errors.has('requested_by')">
            {{ errors.first('requested_by') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label
            class="ts-mb-0 ts-font-robot"
            :class="model.service_request_type_id == 1 ? 'required' : ''"
            >{{ $t('serviceRequest.invoice') }}</label
          >
          <a-select
            v-model="model.stock_out_id"
            :options="invoices"
            allowClear
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('stock_out_id') }"
            placeholder="Select"
            @change="onChangeInvoice"
          ></a-select>
          <div class="validate" v-if="errors.has('stock_out_id')">
            {{ errors.first('stock_out_id') }}
          </div>
        </div>
        <div class="col-md-6">
          <label
            class="ts-mb-0 ts-font-robot"
            :class="model.service_request_type_id == 1 ? 'required' : ''"
            >{{ $t('serviceRequest.product') }}</label
          >
          <a-select
            v-model="model.product_id"
            :options="products"
            allowClear
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('product_id') }"
            placeholder="Select"
            @search="handleSearchProduct"
            :loading="product_searching"
            @change="onChangeProduct"
          ></a-select>
          <div class="validate" v-if="errors.has('product_id')">
            {{ errors.first('product_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0 ts-font-robot">{{
            $t('serviceRequest.serialNo')
          }}</label>
          <a-select
            v-model="model.serial_no"
            :options="serialLists"
            allowClear
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('serial_no') }"
            placeholder="Select"
            @search="handleSearchSerial"
            :loading="serial_searching"
            @change="onChangeSerial"
          ></a-select>
          <div class="validate" v-if="errors.has('serial_no')">
            {{ errors.first('serial_no') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="ts-mb-0">{{ $t('serviceRequest.contact') }}</label>
          <input
            v-model="model.contact_number"
            type="text"
            class="form-control"
          />
          <div class="validate" v-if="errors.has('contact_number')">
            {{ errors.first('contact_number') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="ts-mb-0">
            {{ $t('serviceRequest.serviceProvince') }}
          </label>
          <a-select
            v-model="model.province_code"
            :options="province"
            allowClear
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('province_code') }"
            placeholder="Select"
            @change="onChangeProvince"
          ></a-select>
          <div class="validate" v-if="errors.has('province_code')">
            {{ errors.first('province_code') }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="ts-mb-0">
            {{ $t('serviceRequest.serviceDistrict') }}
          </label>
          <a-select
            v-model="model.district_code"
            :options="district"
            allowClear
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('district_code') }"
            placeholder="Select"
            @change="onChangeDistrict"
          ></a-select>
          <div class="validate" v-if="errors.has('district_code')">
            {{ errors.first('district_code') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="ts-mb-0">
            {{ $t('serviceRequest.serviceCommune') }}
          </label>
          <a-select
            v-model="model.commune_code"
            :options="commune"
            allowClear
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('commune_code') }"
            placeholder="Select"
            @change="onChangeCommune"
          ></a-select>
          <div class="validate" v-if="errors.has('commune_code')">
            {{ errors.first('commune_code') }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="ts-mb-0">
            {{ $t('serviceRequest.serviceVillage') }}
          </label>
          <a-select
            v-model="model.village_code"
            :options="village"
            allowClear
            show-search
            option-filter-prop="children"
            class="ts-w-full"
            :class="{ 'is-invalid': errors.has('village_code') }"
            placeholder="Select"
          ></a-select>
          <div class="validate" v-if="errors.has('village_code')">
            {{ errors.first('village_code') }}
          </div>
        </div>
      </div>
    </div>
    <div>
      <a-modal
        v-model="show_engine"
        :title="$t('borrowingSparePart.engineNumber')"
        :footer="null"
      >
        <table class="ts-w-full ts-mt-3">
          <tbody>
            <tr
              v-for="(serial, index) in serialLists"
              :key="index"
              class="ts-border-b hover:ts-bg-gray-100 ts-cursor-pointer"
              @click="
                onChangeSerial(serial.value, {
                  data: { props: { details: serial.details } }
                })
              "
            >
              <td class="ts-py-2 ts-px-3">
                <div style="line-height: 1.25">
                  <p class="ts-mb-0">
                    INV #: <b>{{ serial.details.invoice_no }}</b>
                  </p>
                  <p class="ts-mb-0">
                    Pro. Name:
                    <b>
                      {{ serial.details.product_name_en }}
                      {{
                        serial.details.product_name_kh
                          ? ' | ' + serial.details.product_name_kh
                          : ''
                      }}
                    </b>
                  </p>
                  <p class="ts-mb-0">
                    VIN Number:<b
                      >{{ serial.details.serial_no }}
                      {{
                        serial.details.imei
                          ? '(' + serial.details.imei + ')'
                          : ''
                      }}</b
                    >
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <Spin size="large" fix v-if="loading"></Spin>
      </a-modal>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  props: ['value', 'validate'],
  components: {},
  data() {
    return {
      loading: false,
      customer_searching: false,
      product_searching: false,
      serial_searching: false,
      show_engine: false,
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('serviceManagement/serviceRequest', ['formViewDatas']),
    customers() {
      if (this.formViewDatas['customers']) {
        return this.formViewDatas['customers'].map(el => ({
          value: el.customer_id,
          label: el.customer_name + ' | ' + el.contact_number
        }))
      }
      return []
    },
    invoices() {
      if (this.formViewDatas['invoices']) {
        return this.formViewDatas['invoices'].map(el => ({
          value: el.stock_out_id,
          label: el.invoice_no + '|' + el.stock_out_date,
          details: el.details.map(item => item.product_id),
          stock_out_date: el.stock_out_date,
          serial_list: el.details.flatMap(item => item.serial_list)
        }))
      }
      return []
    },
    products() {
      if (this.formViewDatas['products']) {
        if (this.model.service_request_type_id == 1) {
          return this.formViewDatas['products']
            .filter(p => p.is_warranty == true)
            .map(el => ({
              value: el.product_id,
              label: el.product_name_en
            }))
        } else {
          return this.formViewDatas['products'].map(el => ({
            value: el.product_id,
            label: el.product_name_en
          }))
        }
      }
      return []
    },
    serialLists() {
      if (this.formViewDatas['serials']) {
        return this.formViewDatas['serials'].map(el => ({
          value: el.serial_no,
          label: el.serial_no + ' | ' + el.imei,
          details: el
        }))
      }
      return []
    },
    province() {
      if (this.formViewDatas['province']) {
        return this.formViewDatas['province'].map(el => ({
          value: el.province_code,
          label: el.name_kh + '|' + el.name_en
        }))
      }
      return []
    },
    district() {
      if (this.formViewDatas['district']) {
        return this.formViewDatas['district'].map(el => ({
          value: el.district_code,
          label: el.name_kh + '|' + el.name_en
        }))
      }
      return []
    },
    commune() {
      if (this.formViewDatas['commune']) {
        return this.formViewDatas['commune'].map(el => ({
          value: el.commune_code,
          label: el.name_kh + '|' + el.name_en
        }))
      }
      return []
    },
    village() {
      if (this.formViewDatas['village']) {
        return this.formViewDatas['village'].map(el => ({
          value: el.village_code,
          label: el.name_kh + '|' + el.name_en
        }))
      }
      return []
    }
  },
  methods: {
    ...mapActions('serviceManagement/serviceRequest', ['getFormViewModel']),
    handleSearchCustomer: debounce(async function(value) {
      this.customer_searching = true
      await this.getFormViewModel({
        index: 'customers',
        params: {
          fnName: 'customers',
          search_customer: value
        }
      })
      this.customer_searching = false
    }, 800),
    handleSearchProduct: debounce(async function(value) {
      this.product_searching = true
      let invoice = this.invoices.find(
        el => el.value == this.model.stock_out_id
      )
      let product_id = invoice ? invoice.details : null

      await this.getFormViewModel({
        index: 'products',
        params: {
          fnName: 'products',
          search_product: value,
          product_id: product_id,
          service_request_type_id: this.model.service_request_type_id
        }
      })
      this.product_searching = false
    }, 800),
    handleSearchSerial: debounce(async function(value) {
      this.serial_searching = true
      await this.getFormViewModel({
        index: 'serials',
        params: {
          fnName: 'serials',
          search_serial: value,
          service_request_type_id: this.model.service_request_type_id
        }
      })
      this.serial_searching = false
    }, 800),
    async onChangeRequestBy(value) {
      this.$emit('setLoading', true)
      this.model.stock_out_id = null
      this.model.product_id = null
      this.model.serial_no = null
      await this.getFormViewModel({
        index: 'invoices,serials',
        params: {
          fnName: 'invoices,serials',
          customer_id: value,
          service_request_type_id: this.model.service_request_type_id
        }
      })
      if (this.formViewDatas['serials'] && this.model.requested_by) {
        this.show_engine = true
      }
      this.$emit('setLoading', false)
    },
    onChangeInvoice(value, option) {
      this.model.product_id = null
      this.model.serial_no = null
      if (value) {
        this.getFormViewModel({
          index: 'products',
          params: {
            fnName: 'products',
            product_id: option.data.props.details,
            service_request_type_id: this.model.service_request_type_id
          }
        })
      }
    },
    async onChangeProduct(value, option) {
      this.model.serial_no = null
      await this.getFormViewModel({
        index: 'serials',
        params: {
          fnName: 'serials',
          product_id: this.model.product_id,
          stock_out_id: this.model.stock_out_id,
          service_request_type_id: this.model.service_request_type_id
        }
      })
    },
    async onChangeSerial(value, option) {
      this.loading = true
      this.model.requested_by = option.data.props.details.customer_id
      this.model.stock_out_id = option.data.props.details.ref_stock_out_id
      this.model.product_id = option.data.props.details.product_id
      this.model.serial_no = value
      await this.getFormViewModel({
        index: 'customers,invoices,products',
        params: {
          fnName: 'customers,invoices,products',
          search_customer: this.model.requested_by,
          stock_out_id: this.model.stock_out_id,
          product_id: [this.model.product_id]
        }
      })
      this.loading = false
      this.show_engine = false
    },
    onChangeProvince(value) {
      this.model.district_code = null
      this.model.commune_code = null
      this.model.village_code = null
      this.getFormViewModel({
        index: 'district',
        params: {
          fnName: 'district',
          province_code: value
        }
      })
    },
    onChangeDistrict(value) {
      this.model.commune_code = null
      this.model.village_code = null
      this.getFormViewModel({
        index: 'commune',
        params: {
          fnName: 'commune',
          district_code: value
        }
      })
    },
    onChangeCommune(value) {
      this.model.village_code = null
      this.getFormViewModel({
        index: 'village',
        params: {
          fnName: 'village',
          commune_code: value
        }
      })
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
.form-control {
  height: 32px;
}
</style>
